import { render, staticRenderFns } from "./ModalInfoAvatar.vue?vue&type=template&id=0c5afc5e"
import script from "./ModalInfoAvatar.vue?vue&type=script&lang=js"
export * from "./ModalInfoAvatar.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoAvatar.vue?vue&type=style&index=0&id=0c5afc5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports